/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { FC } from 'react';
import { themeGet } from '@adminjs/design-system';
import { ResourceJSON } from 'adminjs';

import { branding } from '../../../branding';
import Typography from '../../../components/Typography';
import Button from '../../../components/Button';
import { usePasswordReset } from '../hooks/usePasswordReset';
import {
  Actions,
  Form,
  Logo,
  InfoIcon,
  WelcomeContent,
  Wrapper,
  WelcomeImage,
  WelcomeScreenContainer,
  WelcomeText,
  HeaderText,
  DescriptionText,
} from '../welcome-screen-components';
import { useQuery } from '../hooks/useQuery';

const ResetPassword: FC = () => {
  const { token } = useQuery<{ token: string }>();
  const { onChange, fields, record, onSubmit, isLoading } = usePasswordReset({
    token,
  });

  return (
    <WelcomeScreenContainer>
      <WelcomeImage />
      <WelcomeContent>
        <Wrapper>
          <Logo src={branding.logo as string} />
          <InfoIcon src="/public/icons/reset-password-icon.svg" />
          <WelcomeText>
            <HeaderText>Set a new password for your account</HeaderText>
            <DescriptionText>Please enter your new password</DescriptionText>
            {record.errors.generalError && (
              <Typography color={themeGet('colors', 'error')}>
                {record.errors.generalError.message}
              </Typography>
            )}
          </WelcomeText>
        </Wrapper>
        <Form onSubmit={onSubmit}>
          {fields.map((field) => (
            <field.Component
              key={field.path}
              where="edit"
              resource={{} as ResourceJSON}
              record={record}
              onChange={onChange}
              property={field}
            />
          ))}
          <Actions>
            <Button variant="primary" size="lg" disabled={isLoading}>
              Set password
            </Button>
          </Actions>
        </Form>
      </WelcomeContent>
    </WelcomeScreenContainer>
  );
};

export default ResetPassword;
